import UIManager from "../UIManager/index";
import useStable from "../useStable/index";
function usePlatformMethods({
  pointerEvents,
  style
}) {
  const ref = useStable(() => (hostNode) => {
    if (hostNode != null) {
      hostNode.measure = (callback) => UIManager.measure(hostNode, callback);
      hostNode.measureLayout = (relativeToNode, success, failure) => UIManager.measureLayout(hostNode, relativeToNode, failure, success);
      hostNode.measureInWindow = (callback) => UIManager.measureInWindow(hostNode, callback);
    }
  });
  return ref;
}
var usePlatformMethods_default = usePlatformMethods;
export {
  usePlatformMethods_default as default,
  usePlatformMethods
};
//# sourceMappingURL=index.js.map
